import { QuickSearchInput } from './QuickSearchInput.component';

export { QuickSearchInput };
